<template>
  <div>
    <div
      style="
        line-height: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 7px;
        margin-right: 10px;
        float: left;
      "
    >
      <i
        class="el-icon-s-fold"
        style="font-size: 24px; color: #1362FF; cursor: pointer"
        @click="changeIsCollapse"
        v-if="!isCollapse"
      ></i>
      <i
        class="el-icon-s-unfold"
        style="font-size: 24px; color: #1362FF; cursor: pointer"
        @click="changeIsCollapse"
        v-if="isCollapse"
      ></i>
    </div>

    <el-breadcrumb separator="/" class="breadcrumb-box">
      <el-breadcrumb-item v-for="item in breadcrumb" :key="item.name"
        ><a
          class="breadcrumb-link"
          @click="goToBreadcrumb(item.name)"
          v-if="item.name"
          >{{ item.value }}</a
        ><span class="breadcrumb-span" v-else>{{
          item.value
        }}</span></el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
import bus from "../../utils/bus";

export default {
  name: "breadcrumb",
  data() {
    return {
      isCollapse: bus.global.isCollapse,
    };
  },
  props: {
    breadcrumb: {
      type: Array,
    },
  },
  methods: {
    goToBreadcrumb(name) {
      this.$router.push({
        name: name,
      });
    },

    changeIsCollapse () {
      this.isCollapse = !this.isCollapse
      bus.vue.$emit('changeIsCollapse', this.isCollapse)
    }
  },
};
</script>

<style scoped>
.breadcrumb-box {
  padding: 10px 0;
  border-bottom: 1px solid #e6ebf2;
}
.breadcrumb-link {
  font-size: 14px;
  font-weight: 500;
  color: #97a8be;
}
.breadcrumb-span {
  font-size: 14px;
  color: #48576a;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/Breadcrumb.vue